export default {
    getHeaderFields: state => state.headerFields,
    getPatientHeaderFields: state => state.patientHeaderFields,
    getSearchFields: state => state.searchFields,
    getFormActions: state => state.formActions,
    getActions: state => state.actions,
    getRowActions: state => state.rowActions,
    getDataTableOptions: state => state.dataTableOptions,
    isFormOpen: state => state.formIsOpen,
    isGridOpen: state => state.gridIsOpen,
    //transition
    isPatientGridOpen: state => state.patientGridIsOpen,
    isMergingPatientGridOpen: state => state.mergingPatientGridIsOpen,
    
    getNonMedDocumentTableHeaderFields: state => state.nonMedDocumentTableHeaderFields,
    getNonMedDocumentTableRowActions: state => state.nonMedDocumentTableRowActions,

    getPatientSearchHeaderFields: state => state.patientSearchHeaderFields,
    getPatientTableFields: state => state.patientTableFields,
    getOccuHeaPatientTableFields: state => state.ocuHeaPatientTableFields,
    getSamePatientTableFields: state => state.samePatientTableFields,
    getSamePatientTableOptions: state => state.samePatientSearchDataTableOptions,
    getPatientSearchDataTableOptions: state => state.patientSearchDataTableOptions,
    getPatientSearchRowActions: state => state.patientSearchRowActions,
    getPatientSearchActions: state => state.patientSearchActions,
    getPatientMembershipFormHeaderFields: state => state.patientMembershipFormHeaderFields
}
